import { Component, OnInit, ViewChild } from '@angular/core';
import { DialogControllerService } from '../../services/dialog-controller/dialog-controller.service';
import { BaseViewComponent } from '../base-view/base-view.component';
import { DialogIdentifier } from '../../services/dialog-identifier';
import { DocumentSigningService } from '../../services/document-signing/document-signing.service';
import { NotificationService } from '../../services/notification/notification.service';
import { FileSelectionStoreService } from '../../services/file-selection-store/file-selection-store.service';
import { ProfileStoreService } from '../../services/profile-store/profile-store.service';

@Component({
  selector: 'baf-cert-view',
  templateUrl: './cert-view.component.html',
  styleUrls: ['./cert-view.component.css']
})
export class CertViewComponent extends BaseViewComponent {
  private readonly storedMessageClass = 'cert-message cert-stored';
  private readonly missingMessageClass = 'cert-message cert-missing';
  private readonly storedMessageText = 'Certyfikat jest zarejestrowany';
  private readonly missingMessageText = 'Brak zarejestrowanego certyfikatu';
  private selectedFile: File;
  private password = '';
  readonly selectFileText = 'Wybierz plik z certyfikatem';
  messageText = '';
  messageClass = '';
  isCertificateStored = true;
  isRegisteringMode = false;
  isRegisterEnabled = false;

  constructor(
    dialogController: DialogControllerService,
    private fileStore: FileSelectionStoreService,
    private profileStore: ProfileStoreService,
    private signingService: DocumentSigningService,
    private notifier: NotificationService
  ) {
    super(DialogIdentifier.CertView, dialogController);

    this.signingService.isCertificateStoredStream
      .takeWhile(() => this.isAlive)
      .subscribe(isStored => {
        this.toggleState(isStored);
      });
  }

  onShow() {
    this.clear();
  }

  onHide() {
    this.clear();
  }

  onFileSelected(file: File) {
    this.selectedFile = file;
    this.isRegisteringMode = true;
  }

  onValueChanged(event) {
    this.password = event.value;
    this.isRegisterEnabled = this.password.length > 0;
  }

  onRegisterClick() {
    const file = this.selectedFile;
    const password = this.password;
    this.signingService.verifyCertificate(file, password).then(isValid => {
      if (!isValid) {
        this.notifier.error('Nieprawidłowy plik lub hasło. Certyfikat nie został odczytany.');
      } else {
        this.profileStore.storeCertificatePassword(password).subscribe(() => {
          this.signingService.storeCertificate(file).then(() => {
            this.notifier.success('Certyfikat został zarejestrowany.');
          });
        });
      }
    });
    this.clear();
  }

  onClearClick() {
    this.signingService.clearCertificate();
    this.fileStore.clear();
    this.notifier.success('Certyfikat został usunięty.');
  }

  private clear() {
    this.isRegisteringMode = false;
    this.selectedFile = null;
    this.password = '';
    this.fileStore.clear();
  }

  private toggleState(isStored: boolean) {
    if (isStored) {
      this.messageText = this.storedMessageText;
      this.messageClass = this.storedMessageClass;
      this.isCertificateStored = true;
    } else {
      this.messageText = this.missingMessageText;
      this.messageClass = this.missingMessageClass;
      this.isCertificateStored = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cert-view/cert-view.component.ts